module.exports = __webpack_public_path__ + "img/c_1.d1ae9262.jpg";